// extracted by mini-css-extract-plugin
export default {"img":"PoapImage_img__WgCsC","loaded":"PoapImage_loaded__urgfL"};